import { Button, Modal } from '@payaca/ambrosia';
import { FC, useCallback, useState } from 'react';

import { MaterialPurchaseRecord } from '@/api/queries/project/useGetProjectMaterialListSummaryItems';

import * as materialsListActions from '@payaca/store/materialsList/materialsListActions';
import { useDispatch } from 'react-redux';

export const DeleteMaterialPurchaseRecordModal: FC<{
  materialPurchaseRecord: MaterialPurchaseRecord;
  onClose: () => void;
  isOpen: boolean;
  onDeleteSuccess: () => void;
}> = ({ isOpen, onClose, materialPurchaseRecord, onDeleteSuccess }) => {
  const canDelete = materialPurchaseRecord.isDeletable.result;

  const dispatch = useDispatch();
  const [isProcessing, setIsProcessing] = useState(false);

  const handleDelete = useCallback(() => {
    if (isProcessing) return;
    setIsProcessing(true);
    dispatch(
      materialsListActions.requestDeleteMaterialPurchaseRecord(
        +materialPurchaseRecord.id,
        () => {
          setIsProcessing(false);
          onDeleteSuccess();
        }
      )
    );
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useCallback has missing dependencies: 'dispatch', and 'isProcessing'
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useCallback has unnecessary dependency: onClose
  }, [materialPurchaseRecord.id, onClose, onDeleteSuccess]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Delete record of purchase">
      <Modal.Body>
        {canDelete ? (
          'Are you sure you want to delete?'
        ) : (
          <>
            {materialPurchaseRecord.isDeletable.reasons.map((reason) => (
              <p key={reason}>{reason}</p>
            ))}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Actions>
          {canDelete ? (
            <Button
              colour="negative"
              onClick={handleDelete}
              isProcessing={isProcessing}
            >
              Delete
            </Button>
          ) : (
            <Button onClick={onClose}>Ok</Button>
          )}
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};
